import {createForm} from "final-form";
import {_addCsrfToken, notyf, validateForm} from "../../app/helpers";
import {Modal} from "bootstrap";

const createCustomForm = (
    form,
    initialValues,
    validate
) => {
  const formId = form.getAttribute('id');
  const isAjax = form.classList.contains('js--form_ajax');
  const clearAfterSubmit = form.hasAttribute('data-clear-after-submit');
  const closeModalAfterSubmit = form.hasAttribute('data-close-modal');
  const callbackSuccess = form.getAttribute('data-callback-success');
  const callbackUnsuccess = form.getAttribute('data-callback-unsuccess');
  const callbackFail = form.getAttribute('data-callback-fail');

  const onSubmit = (values, form) => {
    const submitButtons = formElement.querySelectorAll('button[type="submit"], input[type="submit"]');

    if (isAjax) {
      if (submitButtons.length) {
        submitButtons.forEach((button) => {
          button.classList.add('showLoader');
        });
      }

      const formElement = document.getElementById(formId);
      const formData = new FormData(formElement);

      // TODO: remove this
      const companyField = formElement.querySelector('input[name="company"]');
      if (companyField && companyField.classList.contains('hidden')) {
        formData.delete('company');
      }

      if (!formData.has('_csrf')) {
        _addCsrfToken(formData);
      }

      // TODO: remove this
      const productCheckboxes = formElement.querySelectorAll('input[name="product"]:checked');
      if (productCheckboxes) {
        const productValues = Array.from(productCheckboxes).map(checkbox => checkbox.value).join(',');
        formData.set('product', productValues);
      }

      const headers = new Headers({
        'X-Requested-With': 'XMLHttpRequest',
      });

      let redirectUrl = false;

      fetch(formElement.action, {
        method: 'POST',
        body: formData,
        headers: headers,
      })
          .then(response => response.json())
          .then(data => {
            let success = data.success ?? false;
            let notyfType = success ? 'success' : 'error';
            let delay = data.delay ?? 2000;

            if (data.message) {
              notyf[notyfType](data.message).on('dismiss', ({target, event}) => {
                if (data.url) {
                  window.location.href = data.url;
                }
              });
            }

            if (success && typeof window[callbackSuccess] === 'function') {
              data = window[callbackSuccess](data);
            }

            if (!success && typeof window[callbackUnsuccess] === 'function') {
              data = window[callbackUnsuccess](data);
            }

            // TODO: remove this
            if (data.form) {
              document.querySelector('.js--liqpay_form').innerHTML = data.form;
              document.querySelector('.js--liqpay_form').getElementsByTagName('form')[0].submit();
            }

            if (data.url) {
              redirectUrl = true;
              setTimeout(() => {
                if (window.location.href === data.url) {
                  window.location.reload();
                } else {
                  window.location.href = data.url;
                }
              }, delay);
            }

            if (data.errors) {
              Object.keys(data.errors).forEach(field => {
                const formattedField = field.replace(/\./g, '\\.');
                const inputElement = document.querySelector(`[name="${formattedField}"]`);
                if (inputElement) {
                  inputElement.classList.add('invalid');
                  const errorMessages = data.errors[field];
                  errorMessages.forEach(message => {
                    const errorElement = document.getElementById(formattedField + "_error");
                    errorElement.style.display = "block";
                    errorElement.innerHTML = message;
                  });
                }
              });
            }

            if (clearAfterSubmit) {
              form.restart();
              formElement.reset();

              if (window.hasOwnProperty('recaptchaInit') && typeof window.recaptchaInit === 'function') {
                  window.recaptchaInit();
              }

              // TODO: remove this
              // window.initializeForms();
              const phoneInputs = formElement.querySelectorAll('.js--phoneInput');
              if (phoneInputs.length) {
                window.PhoneMask.init('.js--phoneInput', '+380');
              }
            }

            if (closeModalAfterSubmit) {
              const formModal = Modal.getInstance(formElement.closest('.modal'));
              formModal.hide();
            }
          })
          .catch(error => {
            if (submitButtons.length) {
              submitButtons.forEach((button) => {
                button.classList.remove('showLoader');
              });
            }

            if (typeof window[callbackFail] === 'function') {
                window[callbackFail](error)
            }
          })
          .finally(() => {
              if (!redirectUrl) {
                submitButtons.forEach((button) => {
                  button.classList.remove('showLoader');
                });
              }
          })
      ;
    } else {
      // Normal form submission
      const formElement = document.getElementById(formId);
      formElement.submit();
    }
  };
  const formElement = document.getElementById(formId);

  const currentForm = createForm({
    onSubmit,
    initialValues,
    validate,
    mutators: {
      initialValues: () => validateForm(formElement).initialValues,
      validate: () => validateForm(formElement).errors,
      registerField: () => {
        const inputs = formElement.elements;
        [...inputs].forEach((input) => {
          if (input.name && !registered[input.name]) {
            registerField(input, currentForm);
          }
        });
      }
    },
  });


  if (formElement) {
    formElement.addEventListener("submit", (event) => {
      event.preventDefault();
      currentForm.submit();
    });

    const inputs = formElement.elements;
    [...inputs].forEach((input) => {
      if (input.name && !registered[input.name]) {
        registerField(input, currentForm);
      }
    });
  }
  return currentForm;
};


const registered = {};

const updateSubmitButtonState = (formId, form) => {
  const formElement = document.getElementById(formId);
  const submitButtons = formElement.querySelectorAll('button[type="submit"], input[type="submit"]');
  const errors = form.getState().errors;

  const hasVisibleErrors = Object.keys(errors).some((fieldName) => {
    const errorElement = document.querySelector(`.error[data-name="${fieldName}"]`);
    return errorElement && errorElement.style.display === "block";
  });

  submitButtons.forEach((button) => {
    button.disabled = hasVisibleErrors;
  });
};

const normalizeFieldName = (name) => name.replace(/\[|\]/g, '_').replace(/_$/, '');

const registerField = (input, form, formElement) => {
  const rawName = input.name;
  const name = normalizeFieldName(rawName);
  const errorSpan = document.getElementById(rawName + "_error");
  if (errorSpan) {
    errorSpan.setAttribute('data-name', name);
  }

  form.registerField(
      name,
      (fieldState) => {
        const { blur, change, error, focus, touched, value } = fieldState;
        const errorElement = document.querySelector(`.error[data-name="${name}"]`);
        const formId = input.form.id;

        if (!registered[name]) {
          input.addEventListener("blur", () => blur());
          input.addEventListener("input", (event) => {
            if (input.type === 'checkbox') {
              change(event.target.checked);
            } else if (input.type === 'radio') {
              change(event.target.dataset.value);
            } else {
              change(event.target.value);
            }
            if (rawName === 'payment') {
              change(event.target.dataset.value);
            }
          });
          input.addEventListener("change", (event) => {
            let value;
            if (input.type === "checkbox" && name !== 'terms') {
              const checkboxes = formElement.querySelectorAll(`input[name="${rawName}"]:checked`);
              value = Array.from(checkboxes).map(checkbox => checkbox.value);
            } else {
              switch (input.type) {
                case "select-one":
                  value = event.target.value;
                  break;
                case "radio":
                  value = event.target.checked ? event.target.value : null;
                  break;
                case "checkbox":
                  value = event.target.checked;
                  break;
                default:
                  value = event.target.value;
              }
            }
            change(value);
          });
          input.addEventListener("focus", () => focus());
          registered[name] = true;
        }

        if (errorElement) {
          if (touched && error) {
            errorElement.innerHTML = error;
            errorElement.style.display = "block";
            input.classList.add('invalid');
          } else {
            errorElement.innerHTML = "";
            errorElement.style.display = "none";
            input.classList.remove('invalid');
          }
          if (input.type === 'select-one') {
            if (touched && error) {
              errorElement.innerHTML = error;
              errorElement.style.display = "block";
              input.parentElement.parentElement.classList.add('invalid');
            } else {
              errorElement.innerHTML = "";
              errorElement.style.display = "none";
              input.parentElement.parentElement.classList.remove('invalid');
            }
          }
        }

        if (input.type === 'radio') {
          if (error) {
            input.closest('.js--wrapper').classList.add('invalid');
          }
        }
        // form.resetFieldState();
        updateSubmitButtonState(formId, form);
      },
      {
        value: true,
        error: true,
        touched: true,
      }
  );
};
function initializeForms() {
  window.customForms = {};
  const forms = document.querySelectorAll('form.js--form_validation');
  [...forms].forEach((form) => {
    const { initialValues } = validateForm(form);
    window.customForms[form.id] = createCustomForm(
        form,
        initialValues,
        (values) => validateForm(form).errors
    );
  });
}

window.initializeForms = initializeForms;

initializeForms();
